export const SBER_QR_PALETTE = {
  bg: '#07131f',
  panel: '#102334',
  soft: '#162b3d',
  text: '#f5fbff',
  muted: '#8da4b6',
  line: 'rgba(255,255,255,.09)',
  green: '#25d18b',
  bright: '#37eba0',
  brightBg: 'rgba(55,235,160,.12)',
  dark: '#04170e',
} as const;
